import { useEffect, useMemo, useState } from "react";
import { useQueryAppInfo } from "src/queries/info/info.query";
import { useGlobalLocalContext } from "src/storage/localStorage";
import { useShallow } from "zustand/shallow";
import { getFieldTextValues } from "./TimeZoneSelector.utils";

/**
 * Hook that triggers component rerenders at a specified interval
 * @param intervalMs - Interval in milliseconds between rerenders
 * @returns Current timestamp to force rerender
 */
export const useIntervalRerender = (intervalMs: number) => {
  const [, setTick] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      setTick({});
    }, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs]);
};

export const useTimezone = () => {
  const [tz, setTZ] = useGlobalLocalContext(
    useShallow((state) => [state.tz, state.setTZ])
  );
  const timeQuery = useQueryAppInfo();

  const [serverTime, fetchedTime] = useMemo(
    () => [
      timeQuery.data?.time?.now?.substring(
        0,
        timeQuery.data?.time?.now.indexOf("+")
      ),
      Date.now(),
    ],
    [timeQuery.data]
  );

  const [formattedTime, tzStr] = getFieldTextValues(tz, serverTime, fetchedTime);

  return { tz, setTZ, formattedTime, tzStr };
};
